var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn--xl",attrs:{"type":"button","id":"btn-back"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('labels.back')))])}
var staticRenderFns = []

export { render, staticRenderFns }